/* eslint-disable max-len */
/* eslint-disable prefer-destructuring */

export default state => ({
  socialCookiesAccepted: state.cookies.socialCookiesAccepted,
  analyticCookiesAccepted: state.cookies.analyticCookiesAccepted,
});
